import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { clubService, athleteService, eventService } from '../services/api';


// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;



// Icônes SVG professionnelles modernes
const Icons = {
  shield: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M12 7C13.4 7 14.8 8.6 14.8 10V11.5C15.4 11.5 16 12.1 16 12.7V15.5C16 16.1 15.4 16.7 14.8 16.7H9.2C8.6 16.7 8 16.1 8 15.5V12.7C8 12.1 8.6 11.5 9.2 11.5V10C9.2 8.6 10.6 7 12 7M12 8.2C11.2 8.2 10.5 8.7 10.5 9.5V11H13.5V9.5C13.5 8.7 12.8 8.2 12 8.2Z"/>
    </svg>
  ),
  users: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 4C16 5.11 15.11 6 14 6C12.89 6 12 5.11 12 4C12 2.89 12.89 2 14 2C15.11 2 16 2.89 16 4M20 22V16C20 14.9 19.11 14 18 14C17.47 14 16.96 14.21 16.59 14.59C17.79 15.31 18.5 16.6 18.5 18V22H20M12.5 11.5C10.57 11.5 9 13.07 9 15C9 16.93 10.57 18.5 12.5 18.5C14.43 18.5 16 16.93 16 15C16 13.07 14.43 11.5 12.5 11.5M12.5 1C10.57 1 9 2.57 9 4.5C9 6.43 10.57 8 12.5 8C14.43 8 16 6.43 16 4.5C16 2.57 14.43 1 12.5 1M5 8C6.11 8 7 7.11 7 6C7 4.89 6.11 4 5 4C3.89 4 3 4.89 3 6C3 7.11 3.89 8 5 8M7 22V16C7 14.9 6.11 14 5 14C3.89 14 3 14.9 3 16V22H7Z"/>
    </svg>
  ),
  chart: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 21H2V3H4V19H6V17H10V19H12V16H16V19H18V17H22V21M16 8H18V15H16V8M12 10H14V15H12V10M8 5H10V15H8V5Z"/>
    </svg>
  ),
  phone: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5A1 1 0 0 1 21 16.5V20A1 1 0 0 1 20 21A17 17 0 0 1 3 4A1 1 0 0 1 4 3H7.5A1 1 0 0 1 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
    </svg>
  ),
  location: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5S14.5 7.62 14.5 9S13.38 11.5 12 11.5Z"/>
    </svg>
  ),
  medal: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 2H4V4L9.81 8.36C8.72 9.57 8.13 11.22 8.13 13C8.13 16.31 10.82 19 14.13 19C15.91 19 17.56 18.41 18.77 17.32L23 22L24.5 20.5L20 16V2M14.13 17C11.92 17 10.13 15.21 10.13 13C10.13 10.79 11.92 9 14.13 9C16.34 9 18.13 10.79 18.13 13C18.13 15.21 16.34 17 14.13 17Z"/>
    </svg>
  ),
  gallery: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 16V4C22 2.9 21.1 2 20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16M11 12L13.03 14.71L16 11L20 16H8M2 6V20C2 21.1 2.9 22 4 22H18V20H4V6"/>
    </svg>
  )
};

// Types
interface ClubForm {
  nomClub: string;
  nomMaitre: string;
  prenomMaitre: string;
  grade: string;
  telephone: string;
  ville: string;
  quartier: string;
}

interface AthleteForm {
  nom: string;
  prenom: string;
  dateNaissance: string;
  situationMatrimoniale: string;
  situationGeographique: string;
  quartier: string;
  civilite: string;
  telephone: string;
  grade: string;
  contactUrgence: {
    nom: string;
    prenom: string;
    telephone: string;
  };
  aUnClub: boolean;
  clubPreference: string;
  clubSouhaite: string;
  nomMaitre: string;
  telephoneMaitre: string;
}

// Composants stylisés
const MainContent = styled.main`
  flex: 1;
  margin-top: 80px;
`;

// Hero Section - Layout divisé comme sur l'image
const HeroSection = styled.section`
  background: white;
  color: white;
  padding: 0;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const HeroContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 80px 60px;
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #0a192f 0%, #172a45 50%, #263b5c 100%);
  
  @media (max-width: 768px) {
    padding: 60px 30px;
    text-align: center;
  }
`;

const PresidentLabel = styled.div`
  font-size: 1.1rem;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  margin: -18px 0 26px 0;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  position: relative;
  letter-spacing: 0.02em;
  animation: ${fadeInUp} 1s ease-out 0.1s both;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -8px;
    height: 3px;
    border-radius: 3px;
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
  }

  @media (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

const HeroImageSection = styled.div`
  flex: 1.5;
  position: relative;
  background: url("/image d'acceuille.png") center/cover no-repeat;
  
  @media (max-width: 768px) {
    min-height: 300px;
    flex: none;
  }
`;

const HeroTitle = styled.h1`
  font-size: clamp(2.5rem, 4vw, 3.5rem);
  font-weight: 800;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  margin-bottom: 30px;
  line-height: 1.1;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  animation: ${fadeInUp} 1s ease-out;
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const HeroDescription = styled.div`
  font-size: clamp(1.1rem, 2vw, 1.3rem);
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-weight: 400;
  opacity: 0.95;
  max-width: 500px;
  line-height: 1.6;
  margin-bottom: 40px;
  letter-spacing: 0.01em;
  animation: ${fadeInUp} 1s ease-out 0.2s both;
  
  @media (max-width: 768px) {
    text-align: center;
    margin: 0 auto 40px;
  }
`;

const HeroActions = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  animation: ${fadeInUp} 1s ease-out 0.4s both;
  
  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const HeroButton = styled.button`
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 1.1rem;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.02em;
  text-transform: none;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
  }
`;

const HeroVideoButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const VideoIcon = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const VideoText = styled.span`
  font-size: 1rem;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

// Features Section
const FeaturesSection = styled.section`
  padding: 100px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to bottom, white, #f8fafc);
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

// Container plus large uniquement pour la section "Nos Activités"
const FeaturesContainer = styled.div`
  max-width: 1450px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: clamp(2rem, 4vw, 3rem);
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  color: #1e293b;
  margin-bottom: 20px;
  font-weight: 800;
  letter-spacing: -0.01em;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
    border-radius: 2px;
  }
`;

const SectionSubtitle = styled.div`
  text-align: center;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  color: #64748b;
  font-size: 1.1rem;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  font-weight: 400;
  letter-spacing: 0.01em;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-top: 60px;
  animation: ${fadeInUp} 1s ease-out 0.4s both;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: white;
  padding: 50px 38px;
  border-radius: 25px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.08);
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #f1f5f9;
  position: relative;
  overflow: hidden;
  min-height: 460px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #10b981, #059669);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 30px 80px rgba(0,0,0,0.15);
    border-color: #10b981;
  }
  
  &:hover::before {
    transform: scaleX(1);
  }
`;

const FeatureIcon = styled.div`
  width: 95px;
  height: 95px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 2.5rem;
  color: white;
  box-shadow: 0 15px 40px rgba(30, 64, 175, 0.3);
  transition: all 0.3s ease;
  
  ${FeatureCard}:hover & {
    transform: scale(1.1);
    box-shadow: 0 20px 50px rgba(30, 64, 175, 0.4);
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.55rem;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  color: #1e293b;
  margin-bottom: 20px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.01em;
`;

const FeatureDescription = styled.div`
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  color: #64748b;
  line-height: 1.6;
  font-size: 1.02rem;
  font-weight: 400;
  letter-spacing: 0.01em;
`;

// Karateka Section
const KaratekaSection = styled.section`
  padding: 100px 20px;
  background: white;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to bottom, #e2e8f0, white);
  }
`;

const KaratekaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 50px;
  margin-top: 60px;
  animation: ${fadeInUp} 1s ease-out 0.6s both;
`;

const KaratekaCard = styled.div`
  background: white;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #f1f5f9;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 30px 80px rgba(0,0,0,0.15);
    border-color: #fbbf24;
  }
  
  &:hover::before {
    transform: scaleX(1);
  }
`;

const KaratekaImage = styled.div`
  height: 280px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 4rem;
  transition: all 0.4s ease;
  
  ${KaratekaCard}:hover & {
    transform: scale(1.05);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(30, 41, 59, 0.1), rgba(71, 85, 105, 0.3));
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 2;
  }
  
  ${KaratekaCard}:hover &::before {
    opacity: 1;
  }
`;

const KaratekaImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const KaratekaContent = styled.div`
  padding: 30px;
`;

const KaratekaTitle = styled.h3`
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
`;

const KaratekaDescription = styled.div`
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
`;



// Footer
const Footer = styled.footer`
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: white;
  padding: 80px 20px 40px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #fbbf24, #f59e0b, #10b981);
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
`;

const FooterSection = styled.div`
  h3 {
    color: #60a5fa;
    margin-bottom: 25px;
    font-size: 1.3rem;
    font-weight: 700;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 30px;
      height: 2px;
      background: linear-gradient(135deg, #fbbf24, #f59e0b);
      border-radius: 1px;
    }
  }
  
  p {
    color: #cbd5e1;
    line-height: 1.7;
    margin-bottom: 15px;
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
      color: #fbbf24;
    }
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #333;
  color: #999;
`;

// Modal Components
const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
  backdrop-filter: blur(10px);
  animation: ${fadeInUp} 0.3s ease-out;
`;

const ModalContent = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 50px 45px;
  border-radius: 30px;
  max-width: 750px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 30px 100px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.1);
  position: relative;
  animation: ${fadeInUp} 0.4s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  /* Scrollbar personnalisée */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  }
  
  @media (max-width: 768px) {
    padding: 35px 25px;
    border-radius: 25px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 25px;
  right: 25px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #64748b;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  
  &:hover {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    transform: rotate(90deg) scale(1.1);
    box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
  }
  
  &:active {
    transform: rotate(90deg) scale(0.95);
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 10px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
`;

const Label = styled.label<{ required?: boolean }>`
  font-weight: 700;
  color: #1e293b;
  font-size: 0.95rem;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 2px;
  
  ${props => props.required && css`
    &::after {
      content: '*';
      color: #ef4444;
      margin-left: 4px;
      font-weight: 800;
      font-size: 1rem;
    }
  `}
`;

const Input = styled.input`
  padding: 16px 18px;
  border: 2px solid #000000 !important;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
  color: #1e293b;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  
  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
  
  &:hover {
    border-color: #000000 !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  }
  
  &:focus {
    outline: none;
    border-color: #000000 !important;
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
  
  &:invalid {
    border-color: #000000 !important;
  }
  
  &:valid {
    border-color: #000000 !important;
  }
  
  &[required] {
    border-color: #000000 !important;
  }
`;

const Select = styled.select`
  padding: 16px 18px;
  border: 2px solid #000000 !important;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  background: white;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23000000' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 18px center;
  background-size: 12px;
  padding-right: 45px;
  
  &:hover {
    border-color: #000000 !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  }
  
  &:focus {
    outline: none;
    border-color: #000000 !important;
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
  
  &:invalid {
    border-color: #000000 !important;
  }
  
  &:valid {
    border-color: #000000 !important;
  }
  
  &[required] {
    border-color: #000000 !important;
  }
  
  option {
    padding: 12px;
    background: white;
    color: #1e293b;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 0 20px 0;
  padding: 18px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 15px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    border-color: #cbd5e1;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  }
`;

const Checkbox = styled.input`
  width: 22px;
  height: 22px;
  accent-color: #3b82f6;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const CheckboxLabel = styled.label`
  font-weight: 600;
  color: #1e293b;
  font-size: 1rem;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  cursor: pointer;
  user-select: none;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const SubmitButton = styled.button`
  padding: 18px 35px;
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  color: white;
  border: none;
  border-radius: 15px;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(16, 185, 129, 0.4);
    background: linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const ContactUrgenceSection = styled.div`
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  padding: 30px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  }
`;

const ContactUrgenceTitle = styled.h4`
  margin: 0 0 25px 0;
  color: #1e293b;
  font-size: 1.2rem;
  font-weight: 700;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px;
  
  &::before {
    content: '📞';
    font-size: 1.3rem;
  }
`;

const SuccessMessage = styled.div`
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  padding: 18px 22px;
  border-radius: 15px;
  margin-bottom: 25px;
  border: 2px solid #b8e0c2;
  font-weight: 600;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(21, 87, 36, 0.1);
  
  &::before {
    content: '✓';
    font-size: 1.5rem;
    font-weight: 700;
    background: #155724;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const ErrorMessage = styled.div`
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  padding: 18px 22px;
  border-radius: 15px;
  margin-bottom: 25px;
  border: 2px solid #f1aeb5;
  font-weight: 600;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(114, 28, 36, 0.1);
  
  &::before {
    content: '✕';
    font-size: 1.5rem;
    font-weight: 700;
    background: #721c24;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const ClubSearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

const ClubDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #000000 !important;
  border-top: none;
  border-radius: 0 0 12px 12px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  
  /* Scrollbar personnalisée */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 10px;
  }
`;

const ClubOption = styled.div`
  padding: 14px 18px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.1) 0%, rgba(30, 64, 175, 0.05) 100%);
    padding-left: 22px;
  }
  
  &:last-child {
    border-bottom: none;
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
    transform: scaleY(0);
    transition: transform 0.2s ease;
  }
  
  &:hover::before {
    transform: scaleY(1);
  }
`;

const DropdownClubName = styled.div`
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-size: 1rem;
`;

const SearchClubName = styled.h4`
  font-size: 1.5rem;
  color: #1e40af;
  margin-bottom: 8px;
  font-weight: 700;
`;

const ClubVille = styled.div`
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  
  &::before {
    content: '📍';
    font-size: 0.85rem;
  }
`;

// Search Section Components
const SearchSection = styled.section`
  padding: 100px 20px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to bottom, white, #f1f5f9);
  }
`;



const SearchForm = styled.div`
  max-width: 800px;
  margin: 0 auto 60px;
  animation: ${fadeInUp} 1s ease-out 0.8s both;
`;

const SearchFilters = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  background: white;
  padding: 30px;
  border-radius: 25px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.08);
  border: 1px solid #f1f5f9;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 25px;
  }
`;

const SearchInput = styled.input`
  padding: 18px 25px;
  border: 2px solid #e2e8f0;
  border-radius: 25px;
  font-size: 1rem;
  min-width: 250px;
  transition: all 0.3s ease;
  background: #f8fafc;
  
  &:focus {
    outline: none;
    border-color: #1e40af;
    box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
    background: white;
  }
  
  &::placeholder {
    color: #94a3b8;
  }
  
  @media (max-width: 768px) {
    min-width: 280px;
  }
`;

const SearchButton = styled.button`
  padding: 18px 35px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(30, 64, 175, 0.2);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(30, 64, 175, 0.4);
    background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  @media (max-width: 768px) {
    width: 280px;
  }
`;

const SearchResults = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  animation: ${fadeInUp} 1s ease-out 1s both;
`;

const ResultsTitle = styled.h3`
  text-align: center;
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 30px;
  font-weight: 600;
`;

const ClubCard = styled.div`
  background: white;
  border-radius: 25px;
  padding: 40px;
  margin-bottom: 30px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #f1f5f9;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #10b981, #059669);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-10px) scale(1.01);
    box-shadow: 0 30px 80px rgba(0,0,0,0.15);
    border-color: #10b981;
  }
  
  &:hover::before {
    transform: scaleX(1);
  }
`;

const ClubHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
`;



const ClubLocation = styled.div`
  color: #666;
  font-size: 1rem;
`;

const ClubDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ClubMaster = styled.div`
  color: #333;
  font-size: 1rem;
`;

const ClubGrade = styled.div`
  color: #333;
  font-size: 1rem;
`;

const ClubPhone = styled.div`
  color: #333;
  font-size: 1rem;
`;



const NoResults = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
`;

const NoResultsIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 20px;
`;

const NoResultsTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
`;

const NoResultsText = styled.p`
  color: #666;
  font-size: 1rem;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
`;

const ViewAthletesButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 15px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(30, 64, 175, 0.3);
  }
`;

const AthletesModal = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
  border: 2px solid #e1e5e9;
`;

const AthletesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
`;

const ModalAthletesTitle = styled.h5`
  font-size: 1.2rem;
  color: #333;
  margin: 0;
  font-weight: 600;
`;

const AthleteSearchInput = styled.input`
  padding: 10px 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 0.9rem;
  min-width: 250px;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #1e40af;
    box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
  }
  
  @media (max-width: 768px) {
    min-width: 200px;
  }
`;

const AthletesCount = styled.div`
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
`;

const ModalAthletesList = styled.div`
  display: grid;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
`;

const ModalAthleteItem = styled.div`
  background: white;
  padding: 15px;
  border-radius: 10px;
  border-left: 4px solid #1e40af;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateX(5px);
  }
`;

const ModalAthleteName = styled.div`
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 1rem;
`;

const ModalAthleteDetails = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  font-size: 0.9rem;
  color: #666;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
  }
`;

const NoAthletesMessage = styled.div`
  text-align: center;
  padding: 30px;
  color: #666;
  font-style: italic;
`;


function HomePage() {
  const navigate = useNavigate();
  const [showClubForm, setShowClubForm] = useState(false);
  const [showAthleteForm, setShowAthleteForm] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [clubsForDropdown, setClubsForDropdown] = useState<Array<{id: string, nomClub: string, ville: string}>>([]);
  const [filteredClubs, setFilteredClubs] = useState<Array<{id: string, nomClub: string, ville: string}>>([]);
  const [showClubDropdown, setShowClubDropdown] = useState(false);
  const [clubSearchTerm, setClubSearchTerm] = useState('');
  
  // États pour la recherche
  const [searchFilters, setSearchFilters] = useState({
    ville: '',
    quartier: ''
  });
  const [searchResults, setSearchResults] = useState({
    clubs: [] as any[],
    athletesByClub: {} as Record<string, any[]>
  });
  const [searchPerformed, setSearchPerformed] = useState(false);
  
  // États pour l'affichage des athlètes
  const [showAthletesForClub, setShowAthletesForClub] = useState<string | null>(null);
  const [athleteSearchTerm, setAthleteSearchTerm] = useState('');
  const [filteredAthletes, setFilteredAthletes] = useState<any[]>([]);
  
  // État pour les événements
  const [evenements, setEvenements] = useState<any[]>([]);
  const [evenementsLoaded, setEvenementsLoaded] = useState(false);
  const [showAllEvents, setShowAllEvents] = useState(false);
  
  const [clubForm, setClubForm] = useState<ClubForm>({
    nomClub: '',
    nomMaitre: '',
    prenomMaitre: '',
    grade: '',
    telephone: '',
    ville: '',
    quartier: ''
  });
  const [athleteForm, setAthleteForm] = useState<AthleteForm>({
    nom: '',
    prenom: '',
    dateNaissance: '',
    situationMatrimoniale: '',
    situationGeographique: '',
    quartier: '',
    civilite: '',
    telephone: '',
    grade: '',
    contactUrgence: {
      nom: '',
      prenom: '',
      telephone: ''
    },
    aUnClub: false,
    clubPreference: '',
    clubSouhaite: '',
    nomMaitre: '',
    telephoneMaitre: ''
  });
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  // Charger les clubs et événements au montage du composant
  useEffect(() => {
    const loadData = async () => {
      try {
        // Charger les clubs
        const clubsData = await clubService.getAll();
        const approvedClubs = clubsData.filter(club => club.statut === 'approuve');


        // Dropdown (Club souhaité): n'afficher que les clubs approuvés pour l'année en cours
        const currentYear = new Date().getFullYear();
        const approvedClubsCurrentYear = approvedClubs.filter((club: any) => {
          const raw = club?.dateApprobation ?? club?.dateApproval ?? club?.dateModification ?? club?.dateValidation ?? club?.dateCreation;
          if (!raw) return false;
          const d = raw instanceof Date ? raw : new Date(raw);
          return !isNaN(d.getTime()) && d.getFullYear() === currentYear;
        });
        setClubsForDropdown(approvedClubsCurrentYear);
        setFilteredClubs(approvedClubsCurrentYear);
        
        // Charger les événements
        const eventsData = await eventService.getAllEvents();
        const formattedEvents = eventsData.map((event: any) => {
          // Vérifier et formater les dates correctement
          let dateDebut, dateFin;
          
          try {
            // Les dates sont déjà au format ISO complet, on peut les utiliser directement
            if (typeof event.dateDebut === 'string') {
              dateDebut = new Date(event.dateDebut);
            } else if (event.dateDebut instanceof Date) {
              dateDebut = event.dateDebut;
            } else {
              dateDebut = new Date();
            }
            
            if (typeof event.dateFin === 'string') {
              dateFin = new Date(event.dateFin);
            } else if (event.dateFin instanceof Date) {
              dateFin = event.dateFin;
            } else {
              dateFin = new Date();
            }
            
            // Vérifier que les dates sont valides
            if (isNaN(dateDebut.getTime()) || isNaN(dateFin.getTime())) {
              console.warn('Date invalide pour l\'événement:', event.titre, event.dateDebut, event.heureDebut);
              // Utiliser une date par défaut
              dateDebut = new Date();
              dateFin = new Date();
            }
          } catch (error) {
            console.error('Erreur lors du formatage des dates pour l\'événement:', event.titre, error);
            dateDebut = new Date();
            dateFin = new Date();
          }
          
          return {
            id: event.id,
            titre: event.titre,
            description: event.description,
            dateDebut,
            dateFin,
            heureDebut: event.heureDebut,
            heureFin: event.heureFin,
            lieu: event.lieu,
            type: event.type,
            statut: event.statut || 'planifie',
            dateCreation: event.dateCreation,
            dateModification: event.dateModification
          };
        });
        // Filtrer pour ne garder que les événements à venir (aujourd'hui et futur)
        const upcomingEvents = formattedEvents
          .filter((event: any) => {
            const now = new Date();
            const dateFin = new Date(event.dateFin);
            
            // Si l'heure de fin est fournie au format HH:MM(:SS)
            if (event.heureFin) {
              const [hours, minutes] = event.heureFin.split(':');
              dateFin.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
            } else {
              dateFin.setHours(23, 59, 59, 999);
            }
            
            return dateFin >= now;
          })
          .sort((a: any, b: any) => a.dateDebut.getTime() - b.dateDebut.getTime());

        setEvenements(upcomingEvents);
        setEvenementsLoaded(true);
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
        // En cas d'erreur, afficher un message et laisser la liste vide
        setEvenements([]);
        setEvenementsLoaded(true);
      }
    };
    loadData();
  }, []);

  // Filtrer les clubs quand le terme de recherche change
  useEffect(() => {
    if (clubSearchTerm.trim() === '') {
      setFilteredClubs(clubsForDropdown);
    } else {
      const filtered = clubsForDropdown.filter(club => 
        club.nomClub.toLowerCase().includes(clubSearchTerm.toLowerCase()) ||
        club.ville.toLowerCase().includes(clubSearchTerm.toLowerCase())
      );
      setFilteredClubs(filtered);
    }
  }, [clubSearchTerm, clubsForDropdown]);

  // Ajouter les boutons d'affiliation à la navbar via un événement personnalisé
  useEffect(() => {
    const handleShowClubForm = () => setShowClubForm(true);
    const handleShowIndividuelForm = () => setShowAthleteForm(true);

    window.addEventListener('showClubForm', handleShowClubForm);
    window.addEventListener('showIndividuelForm', handleShowIndividuelForm);

    return () => {
      window.removeEventListener('showClubForm', handleShowClubForm);
      window.removeEventListener('showIndividuelForm', handleShowIndividuelForm);
    };
  }, []);

  const handleClubSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await clubService.create(clubForm);
      setMessage({ type: 'success', text: 'Club affilié avec succès !' });
      setClubForm({
        nomClub: '',
        nomMaitre: '',
        prenomMaitre: '',
        grade: '',
        telephone: '',
        ville: '',
        quartier: ''
      });
      setTimeout(() => {
        setShowClubForm(false);
        setShowPaymentModal(true);
      }, 2000);
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de l\'affiliation' });
    }
  };

  
  const handleClubSelect = (club: {id: string, nomClub: string, ville: string}) => {
    setAthleteForm({...athleteForm, clubSouhaite: club.nomClub});
    setClubSearchTerm(club.nomClub);
    setShowClubDropdown(false);
  };

  const handleClubSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setClubSearchTerm(value);
    setAthleteForm({...athleteForm, clubSouhaite: value});
    setShowClubDropdown(true);
  };

  const handleClickOutside = (e: React.MouseEvent) => {
    if (!(e.target as Element).closest('.club-search-container')) {
      setShowClubDropdown(false);
    }
  };

  const handleSearch = async () => {
    if (!searchFilters.ville && !searchFilters.quartier) {
      alert('Veuillez saisir au moins une ville ou un quartier pour rechercher');
      return;
    }

    try {
      setSearchPerformed(true);
      setShowAthletesForClub(null); // Réinitialiser l'affichage des athlètes
      
      // Rechercher les clubs
      const allClubs = await clubService.getAll();
      let localFilteredClubs = allClubs.filter(club => club.statut === 'approuve');
      
      if (searchFilters.ville) {
        localFilteredClubs = localFilteredClubs.filter(club => 
          club.ville.toLowerCase().includes(searchFilters.ville.toLowerCase())
        );
      }
      
      if (searchFilters.quartier) {
        localFilteredClubs = localFilteredClubs.filter(club => 
          club.quartier.toLowerCase().includes(searchFilters.quartier.toLowerCase())
        );
      }

      // Rechercher les athlètes une seule fois pour tous les clubs
      const allAthletes = await athleteService.getAll();
      const athletesByClub: Record<string, any[]> = {};
      
      for (const club of localFilteredClubs) {
        const clubAthletes = allAthletes.filter(athlete => 
          athlete.statut === 'approuve' && 
          (athlete.clubSouhaite === club.nomClub || athlete.clubPreference === club.nomClub)
        );
        
        // Toujours stocker les athlètes, même s'il n'y en a pas
        athletesByClub[club.id] = clubAthletes;
      }

      setSearchResults({
        clubs: localFilteredClubs,
        athletesByClub
      });
    } catch (error) {
      console.error('Erreur lors de la recherche:', error);
      alert('Erreur lors de la recherche. Veuillez réessayer.');
    }
  };

  const handleShowAthletes = (clubId: string) => {
    if (showAthletesForClub === clubId) {
      setShowAthletesForClub(null);
      setAthleteSearchTerm('');
      setFilteredAthletes([]);
    } else {
      setShowAthletesForClub(clubId);
      setAthleteSearchTerm('');
      if (searchResults.athletesByClub[clubId]) {
        setFilteredAthletes(searchResults.athletesByClub[clubId]);
      }
    }
  };

  const handleAthleteSearch = (searchTerm: string) => {
    setAthleteSearchTerm(searchTerm);
    if (showAthletesForClub && searchResults.athletesByClub[showAthletesForClub]) {
      const athletes = searchResults.athletesByClub[showAthletesForClub];
      if (searchTerm.trim() === '') {
        setFilteredAthletes(athletes);
      } else {
        const filtered = athletes.filter(athlete => 
          athlete.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
          athlete.prenom.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredAthletes(filtered);
      }
    }
  };

  const handleAthleteSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // Préparer les données de l'athlète en fonction du checkbox
      const athleteData = {
        ...athleteForm,
        clubPreference: athleteForm.aUnClub ? athleteForm.clubPreference : '',
        nomMaitre: athleteForm.aUnClub ? athleteForm.nomMaitre : '',
        telephoneMaitre: athleteForm.aUnClub ? athleteForm.telephoneMaitre : ''
      };

      await athleteService.create(athleteData);
      setMessage({ type: 'success', text: 'Athlète affilié avec succès !' });
      setAthleteForm({
        nom: '',
        prenom: '',
        dateNaissance: '',
        situationMatrimoniale: '',
        situationGeographique: '',
        quartier: '',
        civilite: '',
        telephone: '',
        grade: '',
        contactUrgence: {
          nom: '',
          prenom: '',
          telephone: ''
        },
        aUnClub: false,
        clubPreference: '',
        clubSouhaite: '',
        nomMaitre: '',
        telephoneMaitre: ''
      });
      setTimeout(() => {
        setShowAthleteForm(false);
        setShowPaymentModal(true);
      }, 2000);
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de l\'affiliation' });
    }
  };

  return (
    <>
      <MainContent>
        {/* Hero Section */}
        <HeroSection>
          <HeroContent>
            <HeroTitle>Association Ivoirienne<br />de Karaté Shotokan</HeroTitle>
            <PresidentLabel>Mot du president</PresidentLabel>
            
            <HeroDescription>
              Révélez le combattant qui est en vous....
              <br />
              Bienvenue dans notre communauté de karaté Shotokan !
              <br />
              Ici, tout commence par une décision : celle de se dépasser.
              <br />
              Rejoignez-nous dès aujourd’hui et entrez dans un univers où rigueur, discipline et passion forgent les esprits et les corps.
              <br />
              Progressez aux côtés d’instructeurs expérimentés, relevez chaque défi et développez des compétences qui vont bien au-delà du dojo.
              <br />
              Débutant ou confirmé, votre parcours vers l’excellence commence ici.
            </HeroDescription>
            
            <HeroActions>
              <HeroButton onClick={() => setShowAthleteForm(true)}>
                Commencer
              </HeroButton>
              
              <HeroVideoButton onClick={() => navigate('/gallery')}>
                <VideoIcon>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </VideoIcon>
                <VideoText>Regarder les vidéos</VideoText>
              </HeroVideoButton>
            </HeroActions>
          </HeroContent>
          
          <HeroImageSection />
        </HeroSection>

        {/* Features Section */}
        <FeaturesSection>
          <FeaturesContainer>
            <SectionTitle>Nos Activités</SectionTitle>
            <SectionSubtitle>
              Découvrez notre gamme complète de services pour le développement du karaté Shotokan
            </SectionSubtitle>
            <FeaturesGrid>
              <FeatureCard>
                <FeatureIcon>{Icons.gallery}</FeatureIcon>
                <FeatureTitle>Historique</FeatureTitle>
                <FeatureDescription>
                  En cours
                </FeatureDescription>
              </FeatureCard>

              <FeatureCard>
                <FeatureIcon>{Icons.shield}</FeatureIcon>
                <FeatureTitle>Gestion des Clubs et leurs affiliations </FeatureTitle>
                <FeatureDescription>
                  <br />• Suivi des membres
                  <br />• Gestion des événements  
                  <br />• Reporting détaillé
                </FeatureDescription>
              </FeatureCard>
              
                             <FeatureCard>
                 <FeatureIcon>{Icons.users}</FeatureIcon>
                 <FeatureTitle>Affiliation Individuelle</FeatureTitle>
                 <FeatureDescription>
                    Processus simplifié d'affiliation des membres.
                   <br />• Gestion des profils
                   <br />• Suivi des progrès
                   <br />• Communication Adaptée
                 </FeatureDescription>
               </FeatureCard>
              
              <FeatureCard>
                <FeatureIcon>{Icons.chart}</FeatureIcon>
                <FeatureTitle>Calendrier Événements à Venir</FeatureTitle>
                <FeatureDescription>
                  {!evenementsLoaded ? (
                    <div style={{ 
                      background: '#f8f9fa', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '10px', 
                      padding: '15px',
                      marginTop: '10px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '1.2rem', marginBottom: '10px' }}></div>
                      <div style={{ fontSize: '0.9rem', color: '#666' }}>Chargement des événements...</div>
                    </div>
                  ) : evenements.length === 0 ? (
                    <div style={{ 
                      background: '#f8f9fa', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '10px', 
                      padding: '15px',
                      marginTop: '10px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '1.2rem', marginBottom: '10px' }}></div>
                      <div style={{ fontSize: '0.9rem', color: '#666' }}>Aucun événement programmé</div>
                    </div>
                  ) : (
                    <div style={{ 
                      background: '#f8f9fa', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '10px', 
                      padding: '15px',
                      marginTop: '10px'
                    }}>
                      <div style={{ 
                        textAlign: 'center', 
                        fontWeight: '600', 
                        color: '#1e40af', 
                        marginBottom: '10px',
                        fontSize: '0.9rem'
                      }}>
                        Événements à venir
                      </div>
                      <div style={{ fontSize: '0.85rem', lineHeight: '1.4' }}>
                        {(showAllEvents ? evenements : evenements.slice(0, 2)).map((event, index) => {
                          const date = event.dateDebut;
                          let day, month, hour;
                          
                          try {
                            // Vérifier que la date est valide
                            if (date instanceof Date && !isNaN(date.getTime())) {
                              day = date.getDate();
                              month = date.toLocaleDateString('fr-FR', { month: 'short' });
                              // Utiliser l'heure séparée si disponible (en enlevant les secondes), sinon extraire de la date
                              hour = (event.heureDebut && event.heureDebut.substring(0, 5)) || date.toLocaleTimeString('fr-FR', { 
                                hour: '2-digit', 
                                minute: '2-digit' 
                              });
                            } else {
                              // Si la date n'est pas valide, utiliser des valeurs par défaut
                              day = '--';
                              month = '---';
                              hour = event.heureDebut || '--:--';
                            }
                          } catch (error) {
                            console.error('Erreur lors du formatage de la date:', error);
                            day = '--';
                            month = '---';
                            hour = event.heureDebut || '--:--';
                          }
                          
                          const eventType = event.type === 'competition' ? '' : 
                                          event.type === 'stage' ? '' : 
                                          event.type === 'examen' ? '' : '';
                          
                          return (
                            <div key={event.id} style={{ 
                              marginBottom: '12px', 
                              padding: '8px', 
                              background: '#f8f9fa', 
                              borderRadius: '8px',
                              border: '1px solid #e9ecef'
                            }}>
                              <div style={{ 
                                fontWeight: '600', 
                                color: '#1e40af',
                                marginBottom: '4px'
                              }}>
                                {day} {month} à {hour}
                              </div>
                              <div style={{ 
                                fontWeight: '500', 
                                color: '#333',
                                marginBottom: '4px'
                              }}>
                                {eventType} {event.titre}
                              </div>
                              <div style={{ 
                                fontSize: '0.8rem', 
                                color: '#666',
                                marginBottom: '4px'
                              }}>
                                {event.lieu}
                              </div>
                              {showAllEvents && (
                                <>
                                  <div style={{ 
                                    fontSize: '0.8rem', 
                                    color: '#666',
                                    marginBottom: '2px'
                                  }}>
                                    {event.heureDebut} - {event.heureFin}
                                  </div>
                                  <div style={{ 
                                    fontSize: '0.8rem', 
                                    color: '#666',
                                    marginBottom: '2px'
                                  }}>
                                    Statut: {event.statut}
                                  </div>
                                  <div style={{ 
                                    fontSize: '0.8rem', 
                                    color: '#666',
                                    fontStyle: 'italic'
                                  }}>
                                    {event.description}
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      
                      {evenements.length > 2 && (
                        <div style={{ 
                          textAlign: 'center', 
                          marginTop: '15px'
                        }}>
                          <button
                            onClick={() => setShowAllEvents(!showAllEvents)}
                            style={{
                              padding: '8px 16px',
                              background: showAllEvents ? '#6c757d' : '#1e40af',
                              color: 'white',
                              border: 'none',
                              borderRadius: '20px',
                              fontSize: '0.8rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.transform = 'translateY(-1px)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            {showAllEvents ? 'Voir moins' : `Voir plus (+${evenements.length - 2})`}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </FeatureDescription>
              </FeatureCard>
              
              
            </FeaturesGrid>
          </FeaturesContainer>
        </FeaturesSection>

        {/* Karateka Section */}
        <KaratekaSection>
          <Container>
            <SectionTitle>Excellence du Karaté</SectionTitle>
            <SectionSubtitle>
              Nos programmes d'entraînement et de formation pour tous les niveaux
            </SectionSubtitle>
            <KaratekaGrid>
              <KaratekaCard>
                <KaratekaImage>
                  <KaratekaImg src="/karate10.webp" alt="Karaté Traditionnel" />
                </KaratekaImage>
                <KaratekaContent>

                  <KaratekaTitle>Karaté Traditionnel</KaratekaTitle>
                  <KaratekaDescription>
                    Respect des valeurs ancestrales du karaté Shotokan. 
                    Transmission des techniques authentiques et de la philosophie 
                    du bushido pour former des karatékas complets.
                  </KaratekaDescription>
                </KaratekaContent>
              </KaratekaCard>
              
              <KaratekaCard>
                <KaratekaImage>
                  <KaratekaImg src="/karate6.jpg" alt="Compétition & Performance" />
                </KaratekaImage>
                <KaratekaContent>
                  <KaratekaTitle>Compétition & Performance</KaratekaTitle>
                  <KaratekaDescription>
                    Préparation aux compétitions nationales et internationales. 
                    Suivi personnalisé des athlètes avec des programmes 
                    d'entraînement adaptés à chaque niveau.
                  </KaratekaDescription>
                </KaratekaContent>
              </KaratekaCard>
              
              <KaratekaCard>
                <KaratekaImage>
                  <KaratekaImg src="/karate7.jpg" alt="Développement Personnel" />
                </KaratekaImage>
                <KaratekaContent>
                  <KaratekaTitle>Développement Personnel</KaratekaTitle>
                  <KaratekaDescription>
                    Le karaté comme outil de développement personnel. 
                    Renforcement de la confiance, de la discipline et 
                    de la concentration pour tous les âges.
                  </KaratekaDescription>
                </KaratekaContent>
              </KaratekaCard>
            </KaratekaGrid>
          </Container>
        </KaratekaSection>

        {/* Search Section */}
        <SearchSection>
          <Container>
            <SectionTitle>Rechercher des Clubs et Athlètes</SectionTitle>
            <SectionSubtitle>
              Trouvez facilement les clubs de karaté et leurs athlètes dans votre région
            </SectionSubtitle>
            
            <SearchForm>
              <SearchFilters>
                <SearchInput
                  type="text"
                  placeholder="Entrez le nom de la ville..."
                  value={searchFilters.ville}
                  onChange={(e) => setSearchFilters({...searchFilters, ville: e.target.value})}
                />
                <SearchInput
                  type="text"
                  placeholder="Entrez le nom du quartier..."
                  value={searchFilters.quartier}
                  onChange={(e) => setSearchFilters({...searchFilters, quartier: e.target.value})}
                />
                <SearchButton onClick={handleSearch}>
                  Rechercher
                </SearchButton>
              </SearchFilters>
            </SearchForm>

            {searchResults.clubs.length > 0 && (
              <SearchResults>
                <ResultsTitle>Résultats de la recherche</ResultsTitle>
                
                {searchResults.clubs.map((club) => (
                  <ClubCard key={club.id}>
                                         <ClubHeader>
                       <SearchClubName>{club.nomClub}</SearchClubName>
                       <ClubLocation>
                         {club.ville} - {club.quartier}
                       </ClubLocation>
                     </ClubHeader>
                    
                    <ClubDetails>
                      <ClubMaster>
                        <strong>Maître :</strong> {club.nomMaitre} {club.prenomMaitre}
                      </ClubMaster>
                      <ClubGrade>
                        <strong>Grade :</strong> {club.grade}
                      </ClubGrade>
                      <ClubPhone>
                        <strong>Téléphone :</strong> {club.telephone}
                      </ClubPhone>
                    </ClubDetails>

                    <ViewAthletesButton 
                      onClick={() => handleShowAthletes(club.id)}
                    >
                      {showAthletesForClub === club.id ? 'Masquer les athlètes' : `Voir les athlètes (${searchResults.athletesByClub[club.id]?.length || 0})`}
                    </ViewAthletesButton>

                    {showAthletesForClub === club.id && searchResults.athletesByClub[club.id] && (
                      <AthletesModal>
                        <AthletesHeader>
                          <ModalAthletesTitle>
                            Athlètes du club {club.nomClub}
                          </ModalAthletesTitle>
                          <AthleteSearchInput
                            type="text"
                            placeholder="Rechercher par nom ou prénom..."
                            value={athleteSearchTerm}
                            onChange={(e) => handleAthleteSearch(e.target.value)}
                          />
                          <AthletesCount>
                            {filteredAthletes.length} athlète(s) trouvé(s)
                          </AthletesCount>
                        </AthletesHeader>

                        {filteredAthletes.length > 0 ? (
                          <ModalAthletesList>
                            {filteredAthletes.map((athlete) => (
                              <ModalAthleteItem key={athlete.id}>
                                <ModalAthleteName>
                                  {athlete.civilite} {athlete.nom} {athlete.prenom}
                                </ModalAthleteName>
                                <ModalAthleteDetails>
                                  <span>Grade: {athlete.grade}</span>
                                  <span>Quartier: {athlete.quartier}</span>
                                  <span>Tél: {athlete.telephone}</span>
                                </ModalAthleteDetails>
                              </ModalAthleteItem>
                            ))}
                          </ModalAthletesList>
                        ) : (
                          <NoAthletesMessage>
                            {athleteSearchTerm ? 'Aucun athlète trouvé pour cette recherche.' : 'Aucun athlète dans ce club.'}
                          </NoAthletesMessage>
                        )}
                      </AthletesModal>
                    )}
                  </ClubCard>
                ))}
              </SearchResults>
            )}

            {searchPerformed && searchResults.clubs.length === 0 && (
              <NoResults>
                <NoResultsIcon></NoResultsIcon>
                <NoResultsTitle>Aucun résultat trouvé</NoResultsTitle>
                <NoResultsText>
                  Aucun club trouvé pour les critères de recherche spécifiés. 
                  Essayez de modifier vos critères de recherche.
                </NoResultsText>
              </NoResults>
            )}
          </Container>
        </SearchSection>

        
      </MainContent>

      {/* Footer */}
      <Footer>
        <FooterContent>
          <FooterSection>
            <h3>Shotokan Karaté Club</h3>
            <p>
              Organisation nationale dédiée à la promotion et au développement 
              du karaté traditionnel Shotokan en Afrique.
            </p>
            <p>
              Notre mission est de former des karatékas exemplaires et de 
              contribuer au développement du sport dans notre pays.
            </p>
          </FooterSection>
          
          <FooterSection>
            <h3>Contact</h3>
            <p>contact@shotokan-karate.africa</p>
            <p>{Icons.phone} +225 27 22 49 74 00</p>
            <p>{Icons.location} Abidjan, Côte d'Ivoire</p>
          </FooterSection>
          
          <FooterSection>
            <h3>Services</h3>
            <p>{Icons.shield} Affiliation des Clubs</p>
            <p>{Icons.users} Affiliation des Athlètes</p>
            <p>{Icons.medal} Organisation de Compétitions</p>
            <p>Formation des Maîtres</p>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; 2026 Shotokan Karaté Club. Tous droits réservés.</p>
        </FooterBottom>
      </Footer>

      {/* Modal Formulaire Club */}
      {showClubForm && (
        <Modal onClick={() => setShowClubForm(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setShowClubForm(false)}>&times;</CloseButton>
            <h2 style={{ 
              marginBottom: '35px', 
              color: '#000000', 
              fontSize: '2.2rem',
              fontFamily: "'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif",
              fontWeight: 900,
              letterSpacing: '-0.02em',
              position: 'relative',
              paddingBottom: '15px'
            }}>
              <span style={{ 
                display: 'inline-block',
                marginRight: '12px',
                fontSize: '2rem'
              }}></span>
              Affiliation Club
            </h2>
            
            {message && (
              message.type === 'success' ? 
                <SuccessMessage>{message.text}</SuccessMessage> : 
                <ErrorMessage>{message.text}</ErrorMessage>
            )}

            <Form onSubmit={handleClubSubmit}>
              <Grid>
                <FormGroup>
                  <Label required>Nom du Club</Label>
                  <Input
                    type="text"
                    value={clubForm.nomClub}
                    onChange={(e) => setClubForm({...clubForm, nomClub: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Nom du Maître</Label>
                  <Input
                    type="text"
                    value={clubForm.nomMaitre}
                    onChange={(e) => setClubForm({...clubForm, nomMaitre: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Prénom du Maître</Label>
                  <Input
                    type="text"
                    value={clubForm.prenomMaitre}
                    onChange={(e) => setClubForm({...clubForm, prenomMaitre: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Grade</Label>
                  <Select
                    value={clubForm.grade}
                    onChange={(e) => setClubForm({...clubForm, grade: e.target.value})}
                    required
                  >
                    <option value="">Sélectionner un grade</option>
                    <option value="Ceinture Blanche">Ceinture Blanche</option>
                    <option value="Ceinture Jaune">Ceinture Jaune</option>
                    <option value="Ceinture Orange">Ceinture Orange</option>
                    <option value="Ceinture Verte">Ceinture Verte</option>
                    <option value="Ceinture Bleue">Ceinture Bleue</option>
                    <option value="Ceinture Marron">Ceinture Marron</option>
                    <option value="Ceinture Noire 1er Dan">Ceinture Noire 1er Dan</option>
                    <option value="Ceinture Noire 2ème Dan">Ceinture Noire 2ème Dan</option>
                    <option value="Ceinture Noire 3ème Dan">Ceinture Noire 3ème Dan</option>
                    <option value="Ceinture Noire 4ème Dan">Ceinture Noire 4ème Dan</option>
                    <option value="Ceinture Noire 5ème Dan">Ceinture Noire 5ème Dan</option>
                    <option value="Ceinture Noire 6ème Dan">Ceinture Noire 6ème Dan</option>
                    <option value="Ceinture Noire 7ème Dan">Ceinture Noire 7ème Dan</option>
                    <option value="Ceinture Noire 8ème Dan">Ceinture Noire 8ème Dan</option>
                    <option value="Ceinture Noire 9ème Dan">Ceinture Noire 9ème Dan</option>
                    <option value="Ceinture Noire 10ème Dan">Ceinture Noire 10ème Dan</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label required>Téléphone</Label>
                  <Input
                    type="tel"
                    value={clubForm.telephone}
                    onChange={(e) => setClubForm({...clubForm, telephone: e.target.value})}
                    placeholder="+225 07 00 00 00 00"
                    pattern="^[\+]?[0-9\s\-\(\)\.]{8,20}$"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Ville</Label>
                  <Input
                    type="text"
                    value={clubForm.ville}
                    onChange={(e) => setClubForm({...clubForm, ville: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Quartier</Label>
                  <Input
                    type="text"
                    value={clubForm.quartier}
                    onChange={(e) => setClubForm({...clubForm, quartier: e.target.value})}
                    required
                  />
                </FormGroup>
              </Grid>

              <SubmitButton type="submit">
                Affilier le Club
              </SubmitButton>
            </Form>
          </ModalContent>
        </Modal>
      )}

      {/* Modal Formulaire Athlète */}
      {showAthleteForm && (
        <Modal onClick={() => setShowAthleteForm(false)}>
          <ModalContent onClick={(e) => {
            e.stopPropagation();
            handleClickOutside(e);
          }}>
            <CloseButton onClick={() => setShowAthleteForm(false)}>&times;</CloseButton>
            <h2 style={{ 
              marginBottom: '35px', 
              color: '#000000', 
              fontSize: '2.2rem',
              fontFamily: "'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif",
              fontWeight: 900,
              letterSpacing: '-0.02em',
              position: 'relative',
              paddingBottom: '15px'
            }}>
              <span style={{ 
                display: 'inline-block',
                marginRight: '12px',
                fontSize: '2rem'
              }}></span>
              Affiliation Individuelle
            </h2>
            
            {message && (
              message.type === 'success' ? 
                <SuccessMessage>{message.text}</SuccessMessage> : 
                <ErrorMessage>{message.text}</ErrorMessage>
            )}

            <Form onSubmit={handleAthleteSubmit}>
              <Grid>
                <FormGroup>
                  <Label required>Nom</Label>
                  <Input
                    type="text"
                    value={athleteForm.nom}
                    onChange={(e) => setAthleteForm({...athleteForm, nom: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Prénom</Label>
                  <Input
                    type="text"
                    value={athleteForm.prenom}
                    onChange={(e) => setAthleteForm({...athleteForm, prenom: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Date de Naissance</Label>
                  <Input
                    type="date"
                    value={athleteForm.dateNaissance}
                    onChange={(e) => setAthleteForm({...athleteForm, dateNaissance: e.target.value})}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Situation Matrimoniale</Label>
                  <Select
                    value={athleteForm.situationMatrimoniale}
                    onChange={(e) => setAthleteForm({...athleteForm, situationMatrimoniale: e.target.value})}
                    required
                  >
                    <option value="">Sélectionner</option>
                    <option value="Célibataire">Célibataire</option>
                    <option value="Marié(e)">Marié(e)</option>
                    <option value="Divorcé(e)">Divorcé(e)</option>
                    <option value="Veuf/Veuve">Veuf/Veuve</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label required>Situation Géographique</Label>
                  <Input
                    type="text"
                    value={athleteForm.situationGeographique}
                    onChange={(e) => setAthleteForm({...athleteForm, situationGeographique: e.target.value})}
                    placeholder="Ville"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Quartier</Label>
                  <Input
                    type="text"
                    value={athleteForm.quartier}
                    onChange={(e) => setAthleteForm({...athleteForm, quartier: e.target.value})}
                    placeholder="Quartier"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Civilité</Label>
                  <Select
                    value={athleteForm.civilite}
                    onChange={(e) => setAthleteForm({...athleteForm, civilite: e.target.value})}
                    required
                  >
                    <option value="">Sélectionner</option>
                    <option value="Monsieur">Monsieur</option>
                    <option value="Madame">Madame</option>
                    <option value="Mademoiselle">Mademoiselle</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label required>Téléphone</Label>
                  <Input
                    type="tel"
                    value={athleteForm.telephone}
                    onChange={(e) => setAthleteForm({...athleteForm, telephone: e.target.value})}
                    placeholder="+225 07 00 00 00 00"
                    pattern="^[\+]?[0-9\s\-\(\)\.]{8,20}$"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label required>Grade</Label>
                  <Select
                    value={athleteForm.grade}
                    onChange={(e) => setAthleteForm({...athleteForm, grade: e.target.value})}
                    required
                  >
                    <option value="">Sélectionner un grade</option>
                    <option value="Ceinture Blanche">Ceinture Blanche</option>
                    <option value="Ceinture Jaune">Ceinture Jaune</option>
                    <option value="Ceinture Orange">Ceinture Orange</option>
                    <option value="Ceinture Verte">Ceinture Verte</option>
                    <option value="Ceinture Bleue">Ceinture Bleue</option>
                    <option value="Ceinture Marron">Ceinture Marron</option>
                    <option value="Ceinture Noire 1er Dan">Ceinture Noire 1er Dan</option>
                    <option value="Ceinture Noire 2ème Dan">Ceinture Noire 2ème Dan</option>
                    <option value="Ceinture Noire 3ème Dan">Ceinture Noire 3ème Dan</option>
                    <option value="Ceinture Noire 4ème Dan">Ceinture Noire 4ème Dan</option>
                    <option value="Ceinture Noire 5ème Dan">Ceinture Noire 5ème Dan</option>
                    <option value="Ceinture Noire 6ème Dan">Ceinture Noire 6ème Dan</option>
                    <option value="Ceinture Noire 7ème Dan">Ceinture Noire 7ème Dan</option>
                    <option value="Ceinture Noire 8ème Dan">Ceinture Noire 8ème Dan</option>
                    <option value="Ceinture Noire 9ème Dan">Ceinture Noire 9ème Dan</option>
                    <option value="Ceinture Noire 10ème Dan">Ceinture Noire 10ème Dan</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label required>Club souhaité</Label>
                  <ClubSearchContainer className="club-search-container">
                    <Input
                      type="text"
                      value={clubSearchTerm}
                      onChange={handleClubSearchChange}
                      onFocus={() => setShowClubDropdown(true)}
                      placeholder="Rechercher un club..."
                      required
                    />
                    {showClubDropdown && filteredClubs.length > 0 && (
                      <ClubDropdown>
                        {filteredClubs.map((club) => (
                          <ClubOption
                            key={club.id}
                            onClick={() => handleClubSelect(club)}
                          >
                            <DropdownClubName>{club.nomClub}</DropdownClubName>
                            <ClubVille>{club.ville}</ClubVille>
                          </ClubOption>
                        ))}
                      </ClubDropdown>
                    )}
                  </ClubSearchContainer>
                </FormGroup>
              </Grid>

              <CheckboxContainer>
                <Checkbox
                  type="checkbox"
                  id="aUnClub"
                  checked={athleteForm.aUnClub}
                  onChange={(e) => setAthleteForm({...athleteForm, aUnClub: e.target.checked})}
                />
                <CheckboxLabel htmlFor="aUnClub">
                  L'athlète a un club de provenance
                </CheckboxLabel>
              </CheckboxContainer>

              {athleteForm.aUnClub && (
                <Grid>
                  <FormGroup>
                    <Label>Club de provenance</Label>
                    <Input
                      type="text"
                      value={athleteForm.clubPreference}
                      onChange={(e) => setAthleteForm({...athleteForm, clubPreference: e.target.value})}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Nom du Maître</Label>
                    <Input
                      type="text"
                      value={athleteForm.nomMaitre}
                      onChange={(e) => setAthleteForm({...athleteForm, nomMaitre: e.target.value})}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Téléphone du Maître</Label>
                    <Input
                      type="tel"
                      value={athleteForm.telephoneMaitre}
                      onChange={(e) => setAthleteForm({...athleteForm, telephoneMaitre: e.target.value})}
                      placeholder="+225 07 00 00 00 00"
                      pattern="^[\+]?[0-9\s\-\(\)\.]{8,20}$"
                    />
                  </FormGroup>
                </Grid>
              )}

              <ContactUrgenceSection>
                <ContactUrgenceTitle>Personne à contacter en cas d'urgence</ContactUrgenceTitle>
                <Grid>
                  <FormGroup>
                    <Label required>Nom</Label>
                    <Input
                      type="text"
                      value={athleteForm.contactUrgence.nom}
                      onChange={(e) => setAthleteForm({
                        ...athleteForm, 
                        contactUrgence: {...athleteForm.contactUrgence, nom: e.target.value}
                      })}
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label required>Prénom</Label>
                    <Input
                      type="text"
                      value={athleteForm.contactUrgence.prenom}
                      onChange={(e) => setAthleteForm({
                        ...athleteForm, 
                        contactUrgence: {...athleteForm.contactUrgence, prenom: e.target.value}
                      })}
                      required
                    />
                  </FormGroup>
                  

                  <FormGroup>
                    <Label required>Téléphone</Label>
                    <Input
                      type="tel"
                      value={athleteForm.contactUrgence.telephone}
                      onChange={(e) => setAthleteForm({
                        ...athleteForm, 
                        contactUrgence: {...athleteForm.contactUrgence, telephone: e.target.value}
                      })}
                      placeholder="+225 07 00 00 00 00"
                      pattern="^[\+]?[0-9\s\-\(\)\.]{8,20}$"
                      required
                    />
                  </FormGroup>
                </Grid>
              </ContactUrgenceSection>

              <SubmitButton type="submit">
                Affilier l'Athlète
              </SubmitButton>
            </Form>
          </ModalContent>
        </Modal>
      )}

      {/* Modal de Paiement */}
      {showPaymentModal && (
        <Modal onClick={() => setShowPaymentModal(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setShowPaymentModal(false)}>&times;</CloseButton>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '2.5rem',
                color: 'white',
                boxShadow: '0 8px 25px rgba(16, 185, 129, 0.35)'
              }}>
                ✓
              </div>
              <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '1.8rem', fontFamily: "'Poppins', sans-serif" }}>
                Demande d'affiliation soumise avec succès !
              </h2>
              <div style={{
                background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                border: '2px solid #bfdbfe',
                borderRadius: '18px',
                padding: '28px 25px',
                margin: '20px 0',
                lineHeight: '1.6',
                color: '#333'
              }}>
                <p style={{ marginBottom: '15px', fontWeight: '700', fontSize: '1.05rem', color: '#1e293b' }}>
                  Pour finaliser votre inscription, veuillez contacter ce numéro afin d'effectuer votre dépôt :
                </p>
                <div style={{
                  background: 'white',
                  borderRadius: '14px',
                  padding: '18px 25px',
                  margin: '12px 0',
                  boxShadow: '0 4px 15px rgba(30, 64, 175, 0.12)',
                  border: '2px solid #1e40af'
                }}>
                  <p style={{
                    fontSize: '1.9rem',
                    fontWeight: '900',
                    color: '#1e40af',
                    margin: 0,
                    letterSpacing: '3px',
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    07 09 14 43 65
                  </p>
                </div>
                <p style={{ marginTop: '15px', color: '#555', fontSize: '0.95rem' }}>
                  Effectuez votre dépôt auprès de cette personne afin de valider définitivement votre affiliation.
                </p>
              </div>
              <div style={{
                background: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: '10px',
                padding: '15px',
                margin: '20px 0',
                color: '#15803d'
              }}>
                <p style={{ margin: 0, fontWeight: '500' }}>
                  Un membre de notre équipe vous contactera dans les plus brefs délais.
                </p>
              </div>
              <button
                onClick={() => setShowPaymentModal(false)}
                style={{
                  padding: '15px 40px',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  cursor: 'pointer',
                  marginTop: '20px',
                  transition: 'all 0.3s ease',
                  fontFamily: "'Poppins', sans-serif",
                  boxShadow: '0 6px 20px rgba(16, 185, 129, 0.3)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(16, 185, 129, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.3)';
                }}
              >
                Compris !
              </button>
            </div>
          </ModalContent>
        </Modal>
      )}

    </>
  );
}

export default HomePage;

